// WhatsApp vaccine-recall tone presets. The universal signature from
// lib/whatsapp.js is appended automatically, so no sign-off here.
import { CLINIC } from "./clinic";

export const RECALL_TONES = [
  { key: "friendly", label: "Friendly", hint: "Warm, welcoming nudge" },
  { key: "firm", label: "Firm", hint: "Direct — don't delay" },
  { key: "clinical", label: "Clinical", hint: "Factual, medical register" },
];

export function getRecallTone() {
  try { return localStorage.getItem("recall_tone") || "friendly"; } catch { return "friendly"; }
}
export function setRecallTone(tone) {
  try { localStorage.setItem("recall_tone", tone); } catch { /* noop */ }
}

export function buildVaccineRecallMsg(tone, { name, vaccine, dateStr, daysUntil }) {
  const first = String(name || "").split(/\s+/)[0] || "there";
  const due = daysUntil != null && daysUntil <= 0
    ? "is due now"
    : `is due on *${dateStr}*`;
  if (tone === "firm") {
    return `Dear ${name || first},\n` +
      `Important: your *${vaccine}* vaccine ${due} and should not be delayed. ` +
      `Timely vaccination is essential for continued protection.\n` +
      `Please book your appointment at ${CLINIC.name} as soon as possible. Reply to confirm.`;
  }
  if (tone === "clinical") {
    return `Dear ${name || first},\n` +
      `Vaccination reminder from ${CLINIC.name}.\n` +
      `Vaccine: *${vaccine}*\nStatus: ${due.replace(/\*/g, "")}\n` +
      `Maintaining the recommended schedule preserves protective immunity. ` +
      `Kindly schedule your visit. Reply to confirm or reschedule.`;
  }
  // friendly (default)
  return `Hello ${first}! 😊\n` +
    `A friendly reminder from ${CLINIC.name} — your *${vaccine}* vaccine ${due}. ` +
    `We'd love to see you; reply here and we'll book a convenient time for you.`;
}
